import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { APP_PRIMARY, NEVADA_GRAY } from 'colours';
import { lifenomeLogoHeader } from 'on_web/assets/imageList';
import {
  ChatActiveIcon,
  ChatInactiveIcon,
  HealthProfileIcon,
  LogoutIcon,
  ResearchIcon,
  ShareIcon,
  SupportIcon,
  ShareCTAIcon,
  ShareCTASmallIcon,
} from 'on_web/assets/iconsList';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import IconButton from '@material-ui/core/IconButton';

import {
  Grid,
  Typography,
  AppBar,
  SwipeableDrawer,
  Box,
  Divider,
} from '@material-ui/core';

import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useUsersApi from 'on_web/hooks/useUsersApi';
import auth0Client from 'on_web/Auth0';

import useCheckScreenSize from 'on_web/hooks/useCheckScreenSize';

import CustomMenuItem from 'on_web/components/shared/Menu/CustomMenuItem/CustomMenuItem';

import {
  ROUTE_ASSESSMENT_HEALTH_RISKS,
  ROUTE_ASSESSMENT_HEALTH_RISKS_GROUPS,
  ROUTE_ASSESSMENT_HEALTH_RISKS_DETAILS,
  ROUTE_ASSESSMENT_DNA_RISKS,
  ROUTE_ASSESSMENT_ENTERPRISE_DEMO,
  ROUTE_ASSESSMENT_DNA_TRAIT_GROUP,
  ROUTE_ASSESSMENT_DNA_TRAIT_DETAILS,
  ROUTE_ASSESSMENT_HOME,
  ROUTE_ASSESSMENT_TERMS_OF_SERVICE,
  ROUTE_ASSESSMENT_RESEARCH,
  ROUTE_ASSESSMENT_SHARE_APP,
  ROUTE_ASSESSMENT_FAQ,
} from 'routes';
import { trackEvent } from 'on_web/helpers/userTrackingEventsHelper';
import { ROUTE_HEALTH_PROFILE } from 'routes';
import { share } from 'on_web/helpers/shareHelper';

function Header(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeIndex, setActiveIndex] = useState(
    props.id !== undefined ? props.id : null
  );
  const [subMenu, setSubMenu] = useState(null);

  const [{ logout }] = useUsersApi();

  const { t } = useTranslation();
  const history = useHistory();
  const [isDesktop] = useCheckScreenSize();

  const drawerWidth = 300;
  const useStyles = makeStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      verticalAlign: 'middle',
      marginBottom: props.squeeze ? '0' : '20px',
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    logoIcon: {
      alignItems: 'flex-start',
      paddingLeft: 30,
      paddingBottom: 5,
    },
    primaryHeader: {
      height: '50px',
      marginLeft: '5px',
      marginRight: '3px',
    },
    secondaryHeader: {
      height: '50px',
      marginLeft: '5px',
      marginRight: '3px',
      borderBottom: '1px Solid #efefef',
    },
    secondaryHeaderWithBackNavigation: {
      height: '50px',
      marginLeft: '5px',
      marginRight: '3px',
    },
    headerTitle: {
      fontFamily: 'Museo-500',
      fontSize: '15px',
      textAlign: 'left',
      color: '#2a343f',
      lineHeight: '22px',
      // 151px = share icon + burger menu width
      maxWidth: `calc(100% - ${isDesktop ? 0 : 151}px)`,
    },
    menuItem: {
      height: '50px',
    },
    menuItemsText: {
      fontFamily: 'Museo-500',
      fontSize: '14px',
      lineHeight: '17px',
    },
    menuItemsIcons: {
      color: '#33b0ce',
      fontSize: '28px',
    },
  });
  const classes = useStyles();
  const menuTitle = t('common.menu.title');

  const menuApps = [
    {
      id: 0,
      path: 'spare',
      text: t('common.menu.extraItems.spare'),
    },
    {
      id: 1,
      path: 'xhealth',
      text: t('common.menu.extraItems.xhealth'),
    },
    {
      id: 2,
      path: 'pce',
      text: t('common.menu.extraItems.pce'),
    },
  ];

  const menuOptions = {
    profileOptions: [
      {
        id: 0,
        icon: (
          <HealthProfileIcon
            fill={activeIndex === 0 ? 'white' : NEVADA_GRAY}
            width="30px"
            height="30px"
          />
        ),
        text: t('common.menu.mainItems.profile'),
        onClick: () => {
          trackEvent('Reporting', 'Menu click PROFILE MOBILE');
          setSubMenu(null);
          setActiveIndex(activeIndex === 0 ? null : 0);
          history.push({
            pathname: ROUTE_HEALTH_PROFILE,
          });
        },
      },
      /*{
        id: 1,
        icon: (
          <SettingsIcon
            fill={activeIndex === 1 ? 'white' : NEVADA_GRAY}
            width="30px"
            height="30px"
          />
        ),
        text: t('common.menu.mainItems.settings'),
        onClick: () => {
          trackEvent('Reporting', 'Menu click SETTINGS MOBILE');
          setSubMenu(null);
          setActiveIndex(activeIndex === 1 ? null : 1);
        },
      },*/
      {
        id: 2,
        icon: (
          <ResearchIcon
            fill={activeIndex === 2 ? 'white' : NEVADA_GRAY}
            width="30px"
            height="30px"
          />
        ),
        text: t('common.menu.research'),
        onClick: () => {
          trackEvent('Reporting', 'Menu click RESEARCH MOBILE');
          setSubMenu(null);
          setActiveIndex(activeIndex === 2 ? null : 2);
          history.push({
            pathname: ROUTE_ASSESSMENT_RESEARCH,
          });
        },
      },
      {
        id: 3,
        icon: (
          <ShareIcon
            fill={activeIndex === 3 ? 'white' : NEVADA_GRAY}
            width="30px"
            height="30px"
          />
        ),
        text: t('common.menu.shareApp'),
        onClick: () => {
          trackEvent('Reporting', 'Menu click SHARE MOBILE');
          setSubMenu(null);
          setActiveIndex(activeIndex === 3 ? null : 3);
          history.push({
            pathname: ROUTE_ASSESSMENT_SHARE_APP,
          });
        },
      },
      {
        id: 4,
        icon: (
          <SupportIcon
            fill={activeIndex === 4 ? 'white' : NEVADA_GRAY}
            width="30px"
            height="30px"
          />
        ),
        text: t('common.menu.support'),
        onClick: () => {
          trackEvent('Reporting', 'Menu click SUPPORT MOBILE');
          setSubMenu(null);
          setActiveIndex(activeIndex === 4 ? null : 4);
          history.push({
            pathname: ROUTE_ASSESSMENT_FAQ,
          });
          /*window.open(
            'mailto:covidsupport@lifenome.com?subject=Fix%20my%20issue!',
            '_blank'
          );*/
        },
      },
      {
        id: 5,
        icon: (
          <LogoutIcon
            fill={activeIndex === 5 ? 'white' : NEVADA_GRAY}
            width="30px"
            height="30px"
          />
        ),
        text: t('common.menu.logout'),
        onClick: () => {
          trackEvent('Reporting', 'Menu click LOGOUT MOBILE');
          setSubMenu(null);
          setActiveIndex(activeIndex === 5 ? null : 5);
          handleLogout();
        },
      },
      /*{
        id: 3,
        icon: (
          <AppsSelectIcon
            fill={activeIndex === 3 ? 'white' : NEVADA_GRAY}
            width="30px"
            height="30px"
          />
        ),
        text: t('common.menu.mainItems.apps'),
        onClick: () => {
          trackEvent('Reporting', 'Menu click APPS MOBILE');
          setSubMenu(menuApps);
          setActiveIndex(activeIndex === 3 ? null : 3);
        },
      },*/
    ],
    extraOptions: [
      {
        id: 6,
        text: t('common.menu.mainItems.about'),
        onClick: () => {
          trackEvent('Reporting', 'Menu click ABOUT LIFENOME MOBILE');
          window.open('https://www.lifenome.com/about/#vision', '_blank');
        },
      },
      {
        id: 7,
        text: t('common.menu.mainItems.termsOfService'),
        onClick: () => {
          trackEvent('Reporting', 'Menu click TERMS OF SERVICE MOBILE');
          history.push({
            pathname: ROUTE_ASSESSMENT_TERMS_OF_SERVICE,
          });
        },
      },
      {
        id: 8,
        text: t('common.menu.mainItems.legalPolicy'),
        onClick: () => {
          trackEvent('Reporting', 'Menu click PRIVACY POLICY MOBILE');
          window.open('https://www.lifenome.com/privacy-policy/', '_blank');
        },
      },
    ],
  };

  const simpleHeader = (
    <header>
      <div className={classes.root}>
        <img
          src={lifenomeLogoHeader}
          width={isDesktop && props.noDesktopSupport ? '300px' : '168px'}
          alt="Lifenome logo"
        ></img>
      </div>
    </header>
  );

  const openMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = event => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    auth0Client.signOut();
  };

  const renderMenu = (
    <SwipeableDrawer
      className={classes.drawer}
      anchorEl={anchorEl}
      anchor="right"
      open={Boolean(anchorEl)}
      onClose={closeMenu}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        className={classes.logoIcon}
      >
        <Grid item>
          <img src={lifenomeLogoHeader} width="168px" alt="Lifenome logo" />
        </Grid>
        <Grid item>
          <Box display="flex" alignItems="center" css={{ height: 50 }}>
            <Box>
              <Typography className={classes.menuItemsText}>
                {menuTitle}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item>
          <IconButton onClick={closeMenu}>
            <CloseIcon fontSize="large" style={{ color: '#33b0ce' }} />
          </IconButton>
        </Grid>
      </Grid>
      <Grid container style={{ height: `100%` }}>
        <Grid
          container
          direction="column"
          justify="space-between"
          style={{ height: 'auto' }}
        >
          <Grid item style={{ marginBottom: 60 }}>
            {menuOptions.profileOptions.map((option, ix) => {
              return (
                <Grid item kex={ix}>
                  <CustomMenuItem
                    index={option.id}
                    backgroundColor={
                      activeIndex === option.id ? APP_PRIMARY : 'white'
                    }
                    icon={option.icon}
                    text={option.text}
                    textColor={
                      activeIndex === option.id ? 'white' : NEVADA_GRAY
                    }
                    upperCase
                    onClick={option.onClick}
                  />
                  <Grid container direction="column">
                    {activeIndex === ix &&
                      subMenu &&
                      subMenu.map(option => {
                        return (
                          <Grid item>
                            <CustomMenuItem
                              index={option.id}
                              text={option.text}
                              style={{
                                paddingLeft: 50,
                              }}
                              onClick={() => {
                                /*let route = getAppRedirectRoute(
                                  option.path,
                                  response.user_metadata
                                );
                                history.push(route);*/
                              }}
                            />
                            <Divider />
                          </Grid>
                        );
                      })}
                  </Grid>
                  <Divider />
                </Grid>
              );
            })}
          </Grid>
          <Grid item style={{ marginBottom: 60 }}>
            {menuOptions.extraOptions.map((option, ix) => {
              return (
                <Grid item kex={ix}>
                  <CustomMenuItem
                    index={option.id}
                    backgroundColor={
                      activeIndex === option.id ? APP_PRIMARY : 'white'
                    }
                    icon={option.icon}
                    text={option.text}
                    textColor={
                      activeIndex === option.id ? 'white' : NEVADA_GRAY
                    }
                    onClick={option.onClick}
                    style={{ paddingLeft: 20 }}
                  />
                  <Divider />
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    </SwipeableDrawer>
  );

  const primaryHeader = (
    <AppBar
      position="sticky"
      style={{ backgroundColor: '#ffffff', boxShadow: 'none' }}
    >
      <div className={classes.root}>
        <Grid
          className={classes.primaryHeader}
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <Grid item>
            <Grid container direction={'row'}>
              {props.showChatIcon && (
                <IconButton onClick={event => props.onChatIconClick(event)}>
                  {props.hasUnreadMessages ? (
                    <ChatActiveIcon fontSize="small" />
                  ) : (
                    <ChatInactiveIcon fontSize="small" />
                  )}
                </IconButton>
              )}
              {props.hasShareAction && (
                <IconButton onClick={() => share(t)}>
                  {props.showChatIcon ? (
                    <ShareCTASmallIcon height="24px" />
                  ) : (
                    <ShareCTAIcon height="30px" />
                  )}
                </IconButton>
              )}
              {props.showChatIcon !== true && props.hasShareAction !== true && (
                <Box width="45px"></Box>
              )}
            </Grid>
          </Grid>
          <img
            xs
            src={lifenomeLogoHeader}
            height="48px"
            alt="Lifenome logo"
            style={{ marginLeft: '-45px' }}
          ></img>
          <IconButton onClick={openMenu}>
            <MenuIcon />
          </IconButton>
          {renderMenu}
        </Grid>
      </div>
    </AppBar>
  );

  const secondaryHeader = (
    <AppBar
      position="sticky"
      style={{
        backgroundColor: '#ffffff',
        boxShadow: 'none',
      }}
    >
      <div className={classes.root}>
        <Grid
          className={classes.secondaryHeader}
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          {props.showChatIcon ? (
            <IconButton>
              {props.hasUnreadMessages ? (
                <ChatActiveIcon fontSize="small" />
              ) : (
                <ChatActiveIcon fontSize="small" />
              )}
            </IconButton>
          ) : props.hasShareAction ? (
            <IconButton onClick={() => share(t)}>
              <ShareCTAIcon height="30px" />
            </IconButton>
          ) : (
            <Box width="45px"></Box>
          )}
          <Typography className={classes.headerTitle}>{props.title}</Typography>
          <IconButton onClick={openMenu}>
            <MenuIcon />
          </IconButton>
          {renderMenu}
        </Grid>
      </div>
    </AppBar>
  );

  const goBack = () => {
    if (history.location.pathname === ROUTE_ASSESSMENT_HEALTH_RISKS_GROUPS) {
      history.push(ROUTE_ASSESSMENT_HEALTH_RISKS);
    } else if (
      history.location.pathname === ROUTE_ASSESSMENT_HEALTH_RISKS_DETAILS
    ) {
      if (props.backToTopLvl) {
        history.push({
          pathname: ROUTE_ASSESSMENT_HEALTH_RISKS,
          state: {
            group: props.selectedGroupCode,
          },
        });
      } else {
        history.push({
          pathname: ROUTE_ASSESSMENT_HEALTH_RISKS_GROUPS,
          state: {
            group: props.selectedGroupCode,
          },
        });
      }
    } else if (history.location.pathname === ROUTE_ASSESSMENT_DNA_TRAIT_GROUP) {
      history.push(ROUTE_ASSESSMENT_DNA_RISKS);
    } else if (history.location.pathname === ROUTE_ASSESSMENT_ENTERPRISE_DEMO) {
      history.push(ROUTE_ASSESSMENT_ENTERPRISE_DEMO);
    } else if (
      history.location.pathname === ROUTE_ASSESSMENT_DNA_TRAIT_DETAILS
    ) {
      if (props.backToTopLvl) {
        history.push({
          pathname: ROUTE_ASSESSMENT_DNA_RISKS,
          state: {
            group: props.selectedGroupCode,
          },
        });
      } else {
        history.push({
          pathname: ROUTE_ASSESSMENT_DNA_TRAIT_GROUP,
          state: {
            group: props.selectedGroupCode,
          },
        });
      }
    } else if (
      history.location.pathname === ROUTE_ASSESSMENT_TERMS_OF_SERVICE
    ) {
      history.goBack();
    } else {
      history.push({
        pathname: ROUTE_ASSESSMENT_HOME,
        state: props.stateToTransferOnNavigation,
      });
    }
  };

  const secondaryHeaderWithBackNavigation = (
    <AppBar
      position="sticky"
      style={{ backgroundColor: '#ffffff', boxShadow: 'none' }}
    >
      <div className={classes.root}>
        <Grid
          className={classes.secondaryHeaderWithBackNavigation}
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <IconButton onClick={() => goBack()}>
            <ArrowBackIosIcon fontSize="small" />
          </IconButton>
          <Typography xs className={classes.headerTitle}>
            {props.title}
          </Typography>
          <IconButton onClick={openMenu}>
            <MenuIcon />
          </IconButton>
          {renderMenu}
        </Grid>
      </div>
    </AppBar>
  );

  const secondaryHeaderWithShareAction = (
    <AppBar
      position="sticky"
      style={{ backgroundColor: '#ffffff', boxShadow: 'none' }}
    >
      <div className={classes.root}>
        <Grid
          className={classes.secondaryHeaderWithShareAction}
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <IconButton onClick={() => goBack()}>
            <ShareCTAIcon fontSize="small" />
          </IconButton>
          <Typography xs className={classes.headerTitle}>
            {props.title}
          </Typography>
          <IconButton onClick={openMenu}>
            <MenuIcon />
          </IconButton>
          {renderMenu}
        </Grid>
      </div>
    </AppBar>
  );

  const renderHeader = () => {
    if (props.secondaryHeaderWithBackNavigation) {
      return secondaryHeaderWithBackNavigation;
    } else if (props.secondaryHeaderWithShareAction) {
      return secondaryHeaderWithShareAction;
    } else if (props.secondaryHeader) {
      return secondaryHeader;
    } else if (props.primaryHeader) {
      return primaryHeader;
    } else {
      return simpleHeader;
    }
  };

  return isDesktop && props.noDesktopSupport !== true ? (
    <React.Fragment />
  ) : (
    renderHeader()
  );
}

export default Header;
